// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"87f05a9c","453":"3ff9bf92"}[chunkId] + ".chunk.js";
};